import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Blog } from "../../utils/apis/blog/Blog";
import { Context } from "../../utils/context";
import { IDS } from "../../utils/common";
import Free_Consultation from "../home/free-consultation/Free_Consultation";
import "./Blogs.css";
import Blogs_card from "./blogs_card/Blogs_card";
import Common_heading from "../common/common_heading/Common_heading";
import { SolarInsights } from "../../utils/apis/homepage";

const Blogs = () => {
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);

  const [blog, setBlog] = useState([]);
  const [techInsight, setTechInsight] = useState([]);



  const FALLBACK_BLOG_DATA = [];

  const getTechInsights = useCallback(async () => {
    try {
      const res = await SolarInsights();

      if (res?.success && res.data?.length > 0) {
        setTechInsight(res.data);
      } else {
        setTechInsight(FALLBACK_BLOG_DATA);
      }
    } catch (error) {
      console.error("Failed to fetch tech insights:", error);
      setTechInsight(FALLBACK_BLOG_DATA);
    }
  }, []);

  useEffect(() => {
    getTechInsights();
  }, [getTechInsights]);

  const handleServiceClick = (id) => {
    navigate(`/blog/${id}`);
  };

  const getBlog = async () => {
    const res = await Blog();

    if (res?.success) {
      setBlog(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getBlog();
  }, []);

  // HTML Parser
  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  return (
    <>
      <section className="Blogs">
        <div className="container">

          {/* Heading Animation */}
          <div >
            <Common_heading
              title="Blogs"
              subtitle="Explore our latest insights, industry trends, and expert advice on all things digital marketing. Stay informed and inspired with our regularly updated blog posts."
            />
          </div>

          {/* Blog Cards Animation */}
          <div >
            <Blogs_card
              blog={techInsight}
              handleServiceClick={handleServiceClick}
              htmlToReactParser={htmlToReactParser}
              IMG_URL={IMG_URL}
              IDS={IDS}
            />
          </div>


        </div>
          {/* Consultation Animation */}
          <div >
            <Free_Consultation />
          </div>
      </section>
    </>
  );
};

export default Blogs;